module.exports = __webpack_public_path__ + "27f5d06dc59b394e1a8c5a8e370aec43.svg";